import { FC } from 'react';
import { Box, Text, Button, VStack, HStack, Code } from '@chakra-ui/react';
import {
  DialogRoot,
  DialogContent,
  DialogHeader,
  DialogBody,
  DialogFooter,
  DialogTitle,
} from '@/components/ui/dialog';
import { toaster } from '@/components/ui/toaster';

interface InitialPasswordDialogProps {
  open: boolean;
  title: string;
  email: string;
  password: string;
  onClose: () => void;
}

/**
 * 発行パスワード表示ダイアログコンポーネント
 * パスワードは一度だけ表示される。誤操作で閉じないよう外側クリック・Escapeでは閉じない。
 */
export const InitialPasswordDialog: FC<InitialPasswordDialogProps> = ({
  open,
  title,
  email,
  password,
  onClose,
}) => {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(password);
      toaster.success({ title: 'パスワードをコピーしました' });
    } catch {
      toaster.error({ title: 'コピーに失敗しました', description: '手動で控えてください' });
    }
  };

  return (
    <DialogRoot open={open} closeOnInteractOutside={false} closeOnEscape={false}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <VStack align="stretch" gap={4}>
            <Box>
              <Text fontSize="sm" color="gray.600">
                メールアドレス
              </Text>
              <Text fontWeight="medium">{email}</Text>
            </Box>
            <Box>
              <Text fontSize="sm" color="gray.600" mb={1}>
                パスワード
              </Text>
              <HStack gap={3}>
                <Code fontSize="lg" p={2} flex={1} textAlign="center">
                  {password}
                </Code>
                <Button size="sm" variant="outline" onClick={handleCopy}>
                  コピー
                </Button>
              </HStack>
            </Box>
            <Box p={3} bg="orange.50" borderRadius="md" borderWidth={1} borderColor="orange.200">
              <Text fontSize="sm" color="orange.700">
                ⚠ このパスワードは二度と表示されません。必ず控えてから閉じてください。
              </Text>
            </Box>
          </VStack>
        </DialogBody>
        <DialogFooter>
          <Button colorPalette="blue" onClick={onClose}>
            閉じる
          </Button>
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  );
};
